(function ($) {
    //   console.log("hello");
    //   console.log($(".filter-input"));
  
    function rebind_pagination() {
      $(".page-template-listings .pagination li a").unbind();
      $(".page-template-listings  .pagination li a").on("click", function (e) {
        e.preventDefault();
        var post_type = $("#main").data("post-type");
        var page = parseInt($(this).text());
        console.log(page);
  
        $("html, body").animate(
          {
            scrollTop: $(".property-listings").offset().top - 230,
          },
          350,
          "linear"
        );
  
        get_properties(post_type, page, search_filters);
      });
    }
  
    /**
     * Search Functions
     */
    rebind_pagination();
  
    var search_filters = [];
    console.log($(".filter-input"));
    $(".filter-input").each(function () {
      var input = $(this);
      var type = input.data("filter");
      var index = input.data("filter-index");
      var filter_value = input.val();
      var checked = input.prop("checked");
      var post_type = $("#main-archive").data("post-type");
      console.log(filter_value);
  
      if (checked) {
        add_to_search_filters(index, type, filter_value);
      }
  
      //get_properties( post_type, 1, search_filters );
    });
  
    $(".filter-input").change(function () {
      var input = $(this);
      var type = input.data("filter");
      var index = input.data("filter-index");
      var filter_value = input.val();
      var checked = input.prop("checked");
      var post_type = $("#main-archive").data("post-type");
  
      // console.log(filter_value);
  
      $(".filter-loading").show();
  
      if (checked) {
        add_to_search_filters(index, type, filter_value);
        // console.log(filter_value);
      } else {
        remove_from_search_filters(index, type, filter_value);
      }
  
      if (post_type == "expo_events") {
        get_properties(post_type, 1, search_filters);
      }
    });
  
    $(".clear-all").on("click", function () {
      $(".clear-all").addClass("hide");
      $(".clear-all").removeClass("show");
    });
  
    $(".post-type-archive-expo_events .clear-all").on("click", function () {
      $(".filter-input").each(function (index, input) {
        $(input).prop("checked", false);
      });
  
      search_filters = [];
      var post_type = $("#main-archive").data("post-type");
      console.log(post_type);
  
      get_properties(post_type, 1, search_filters);
    });
  
    function checkSearchFilters(search_filters_count) {
      //console.log('checkSearchFilters');
      //console.log(search_filters.length);
      if (search_filters_count == 0) {
        $(".clear-all").removeClass("show");
        $(".clear-all").addClass("hide");
      }
    }
  
    function add_to_search_filters(index, type, filter_value) {
      /*search_filters.push({
        type: type,
        value: filter_value
      });*/
  
      if (search_filters[index] === undefined) {
        search_filters[index] = [filter_value];
      } else {
        search_filters[index].push(filter_value);
      }
  
      if ($(".clear-all").hasClass("hide")) {
        $(".clear-all").addClass("show");
        $(".clear-all").removeClass("hide");
      }
  
      // if ($("#no-results")) {
      //   console.log("no results");
      //   $(".filter-column").addClass("hide");
      //   $(".desk-filter-toggle").addClass("show-filters");
      //   $("body").addClass("no-results");
      // }
    }
  
    function remove_from_search_filters(index, type, filter_value) {
      var search_arr = search_filters[index];
      var found_index = -1;
      for (i = 0; i < search_arr.length; i++) {
        if (search_arr[i] == filter_value) {
          found_index = i;
        }
      }
  
      if (found_index > -1) {
        var replace = search_arr
          .slice(0, found_index)
          .concat(search_arr.slice(found_index + 1, search_arr.length));
        search_filters[index] = replace;
      }
  
      //console.log('check filters')
      //console.log(search_filters);
  
      /*var check_type = search_filters.map(function(e) { return e.type; }).indexOf(type);
      var check_value = search_filters.map(function(e) { return e.value; }).indexOf(filter_value);
  
      if ( check_type > -1 && check_value > -1 ) {
        if ( check_type === check_value ) {
          search_filters = search_filters.slice(0, check_type).concat(search_filters.slice(check_type + 1, search_filters.length));
        }
      }*/
    }
  
    function get_properties(post_type, page, search_filters) {
      console.log(post_type + ' is post type');
      console.log(page + ' is page');
      console.log(search_filters + ' is search filters');


      var data = {
        action: "filter_search",
        search_filters: search_filters,
        post_type: post_type,
        page: page,
        nonce: kpa.nonce,
      };
      // console.log(data);
      // console.log(post_type);
  
      var request = call_ajax_request(data);
      request.done(function (response) {
        console.log(response);
        $(".event-listing").html("");
        $(".event-listing").html(response.html);
        //   checkSearchFilters(data.search_filters.length);
          // console.log(checkSearchFilters(data.search_filters.length));
        //   rebind_pagination();
  
        //   history.replaceState({}, "Page: " + page, "?pages=" + page);
        //   $(".filter-loading").hide();
      });

      console.log(JSON.stringify(request) + ' is request');
  
      request.fail(function (error) {
        console.log("error");
        console.log(error);
      });
    }
  
    function call_ajax_request(data) {
      $.support.cors = true;
      var request = $.ajax({
        type: "post",
        dataType: "json",
        url: kpa.ajax_url,
        data: data,
      });
      console.log(kpa.ajax_url + ' is kpa.ajax_url');
      return request;
    }
  
    /**
     * Filter Nav
     */
    /*$('.filter-nav-toggle').on('click', function() {
      console.log('filter-nav toggle')
      $(this).parent('.filter-menu').toggleClass('show');
    });*/
  
    $(".toggle-open").on("click", function () {
      // console.log("menu is open");
      $(".filter-menu").addClass("show");
      $(".mobile-filter-toggle>h5").addClass("open");
      $("body").addClass("filter-menu-open");
  
      $(".category_filter__links").toggleClass("show");
    });
  
  //   $(".toggle-open.show-filters").on("click", function () {
  //     //   alert('hello');
  //     $("body").toggleClass("filter-menu-open");
  //   });
  
    $(".toggle-close").on("click", function () {
      $(".filter-menu").removeClass("show");
      $(".mobile-filter-toggle>h5").removeClass("open");
      $("body").removeClass("filter-menu-open");
  
      deskToggleFilters();
    });
  
    $(".page-filter-overlay").on("click", function () {
      $(".filter-menu").removeClass("show");
      $(".mobile-filter-toggle>h5").removeClass("open");
      $("body").removeClass("filter-menu-open");
  
      deskToggleFilters();
    });
  
    $(".filter-toggle").on("click", function () {
      //$(this).parent().parent('.filter-type').find('.filter-list').toggleClass('show');
      // console.log(this);
      $(this).parent(".filter-type").find(".filter-list").slideToggle(300);
      $(this).find(".filter-icon span").toggleClass("icon-collapse");
      $(this).find(".filter-icon span").toggleClass("icon-expand");
    });
  
  //   if ($("#no-results")) {
  //     console.log("no results");
  //     $(".filter-column").addClass("hide");
  //   }
  
    $(".desk-filter-toggle").on("click", deskToggleFilters);
  
    function deskToggleFilters() {
      $(".desk-filter-toggle").toggleClass("show-filters");
      $(".listing-content-area").toggleClass("show-filters");
      var text = $(".desk-filter-toggle").text();
  
      // $(".filter-column").toggleClass("hide");
  
      if ($(".desk-filter-toggle").hasClass("show-filters")) {
        var text_replace = text.replace("Show", "Hide");
        $(".desk-filter-toggle").html(
          text_replace + ' <span class="main-filter-icon filters-showing"> '
        );
      } else {
        var text_replace = text.replace("Hide", "Show");
        $(".desk-filter-toggle").html(
          text_replace + ' <span class="main-filter-icon filters-hidden"> '
        );
      }
    }
  
    $(".search-btn").on("click", function () {
      $(this).parent().toggleClass("show");
  
      if ($(".search-events-container").hasClass("show")) {
        $(".search-text").text("Hide Search Optons");
      } else {
        $(".search-text").text("Show Search Optons");
      }
    });
  })(jQuery);
  